import React, { Component } from 'react'
import { database } from './firebase'
import { compare } from './compare'
import { connect } from 'react-redux'
import { setPostGameAction } from './reducers/reducers'
import { resultCreator, addResult } from './reducers/results'


const TIMEOUT = 2000
const TIMEOUT_INTERVAL = 200


const responses = database.ref('responses')


class App extends Component {
    constructor(props) {
        super(props)

        this.state = {
              index: 0
            , stage: 0 // 0 - show first image, 1 show second image
            , loading: true
            , time: 0
        }
    }

    next() {
        this.setState({stage: 1, loading: true})
    }

    respond(res) {
        const index = this.state.index
        const currentImageSet = this.props.images[index]
        const _this = this

        compare(currentImageSet.first.url, currentImageSet.second.url)
            .then(function(data) {
                const result = resultCreator(currentImageSet.id, currentImageSet.same, res, data.data.distance)
                responses.push().set(result)
                _this.props.addResult(result)
            })
            .catch(function(err) {
                const result = resultCreator(currentImageSet.id, currentImageSet.same, res, 1000)
                responses.push().set(result)
                _this.props.addResult(result)
            })
            
        const nextIndex = _this.state.index + 1
        if (nextIndex === _this.props.images.length) {
            _this.props.showResult()
        } else {
            _this.setState({stage: 0, index: nextIndex, loading: true})
        }
    }

    renderControl() {
        if (this.state.stage === 0) {
            const time = (this.state.time !== 0) ? 'Time left: ' + this.state.time / 1000 + 's' : ''
            return (
                <div>
                    { time }
                </div>
            )
        } else {
            const question = this.state.stage === 1 ? 'Is this the same person?' : null
            return (
                <div>
                    <h5>{ question }</h5>
                    <div className='expanded button-group'>
                        <button className="button alert" onClick={this.respond.bind(this, false)}>Different</button>
                        <button className="button success" onClick={this.respond.bind(this, true)}>The same</button>
                    </div>
                </div>
            )
        }
    }

    renderImage() {
        if (this.props.images.length === 0) {
            return (
                <div>No images</div>
            )
        } else {
            const i = this.state.index
            const pair = this.props.images[i]
            const url = this.state.stage === 0 ? pair.first.url : pair.second.url

            const onLoad = () => {
                this.setState({loading: false})
                if (this.state.stage === 0) {
                    this.setState({time: TIMEOUT})
                    const _this = this
                    const inv = setInterval(function() {
                        if (_this.state.time <= 0) {
                            // Time up
                            clearInterval(inv)
                            _this.next()
                        } else {
                            _this.setState({time: _this.state.time - TIMEOUT_INTERVAL})
                        }
                    }, TIMEOUT_INTERVAL)
                }
            }

            return (
                <img className='face-image' src={url} alt='img' onLoad={onLoad} />
            )
        }
    }

    render() {
        const img = this.renderImage()
        const control = this.renderControl()
        
        const loadingIcon = this.state.loading ? <div className='circle loading'>Loading image</div> : <div className='circle ready'></div>

        return (
            <div>
                <div className="card">
                  <div className='card-divider'>                    
                    { loadingIcon }
                  </div>
                  { img }
                  <div className="card-section">
                    { control }
                  </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    images: state.images
})

const mapDispatchToProps = (dispatch) => ({
    addResult: (result) => dispatch(addResult(result)),
    showResult: () => dispatch(setPostGameAction())
})

export default connect(mapStateToProps, mapDispatchToProps)(App)



// WEBPACK FOOTER //
// ./src/App.js